import { useState, FormEvent } from 'react';
import { Button } from '../ui/Button';
import './TableForm.css';

interface TableFormProps {
  initialData?: {
    name: string;
    location?: string;
  };
  onSubmit: (data: { name: string; location?: string }) => Promise<void>;
  onCancel: () => void;
  submitLabel?: string;
}

export function TableForm({ initialData, onSubmit, onCancel, submitLabel = 'Salvar' }: TableFormProps) {
  const [name, setName] = useState(initialData?.name || '');
  const [location, setLocation] = useState(initialData?.location || '');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);

    if (!name.trim()) {
      setError('Nome da mesa é obrigatório');
      return;
    }

    setIsSubmitting(true);
    try {
      await onSubmit({
        name: name.trim(),
        location: location.trim() || undefined,
      });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Erro ao salvar mesa');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form className="table-form" onSubmit={handleSubmit}>
      <div className="table-form__field">
        <label htmlFor="name" className="table-form__label">
          Nome da Mesa *
        </label>
        <input
          id="name"
          type="text"
          className="table-form__input"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Ex: Mesa 1"
          required
          disabled={isSubmitting}
        />
      </div>

      <div className="table-form__field">
        <label htmlFor="location" className="table-form__label">
          Localização
        </label>
        <input
          id="location"
          type="text"
          className="table-form__input"
          value={location}
          onChange={(e) => setLocation(e.target.value)}
          placeholder="Ex: Sala Principal"
          disabled={isSubmitting}
        />
      </div>

      {error && <div className="table-form__error">{error}</div>}

      <div className="table-form__actions">
        <Button type="button" variant="secondary" onClick={onCancel} disabled={isSubmitting}>
          Cancelar
        </Button>
        <Button type="submit" disabled={isSubmitting}>
          {isSubmitting ? 'Salvando...' : submitLabel}
        </Button>
      </div>
    </form>
  );
}
